import { INFO_LETTERS, SYSTEM_NOTIFICATIONS } from 'utils/constants/settings';

import { Requirements } from 'app/routes';

import { setInfoLetters, setSystemNotifications } from 'store/models/settings';

export const SubscriptionSettingsRequirements: Requirements<{
    settings: { [INFO_LETTERS]: boolean; [SYSTEM_NOTIFICATIONS]: boolean };
}> = {
    methods: () => ({
        settings: { url: '/api/v1/settings', cacheable: false },
    }),
    resolve: ({ result: { settings } }) => [
        setInfoLetters(settings[INFO_LETTERS]),
        setSystemNotifications(settings[SYSTEM_NOTIFICATIONS]),
    ],
};
